import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import img2 from "../assets/2.png";
import img3 from "../assets/3.png";
import img4 from "../assets/4.png";
import Banner1 from "../assets/Banner1.jpg";
import Banner2 from "../assets/Banner2.jpg";
import Banner3 from "../assets/Banner3.jpg";
import "../styles/Home.css";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

const slides = [
  {
    id: 1,
    image: Banner1,
    title: "Creating Abodes of Happiness",
    subtitle: "Building with trust, quality, and a vision for better living.",
  },
  {
    id: 2,
    image: Banner2,
    title: "Transforming Real Estate",
    subtitle: "Delivering innovative spaces with excellence and care.",
  },
  {
    id: 3,
    image: Banner3,
    title: "Vision Beyond Construction",
    subtitle: "Where every project becomes a landmark of happiness.",
  },
];

const variants = {
  enter: (direction) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction) => ({
    x: direction < 0 ? 300 : -300,
    opacity: 0,
  }),
};

const Home = () => {
  const [[page, direction], setPage] = useState([0, 0]);
  const navigate = useNavigate();

  const paginate = (newDirection) => {
    setPage(([prev]) => [
      (prev + newDirection + slides.length) % slides.length,
      newDirection,
    ]);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      paginate(1);
    }, 5000);
    return () => clearInterval(interval);
  }, [page]);

  const currentSlide = slides[page];

  return (
    <>
      {/* Hero Slider */}
      <motion.div className="page" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <div className="carousel-container">
          <AnimatePresence custom={direction}>
            <motion.div
              key={currentSlide.id}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.6, ease: "easeInOut" }}
              className="slide"
              style={{
                backgroundImage: `url(${currentSlide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="slide-overlay" />

              <motion.div
                className="slide-content"
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
              >
                <h1 className="slide-title">{currentSlide.title}</h1>
                <p className="slide-subtitle">{currentSlide.subtitle}</p>

                {/* Tagline Added */}
                <h3 className="tagline">
                  The Gold Standard in Luxury Living
                </h3>

                <button
                  className="cta-button"
                  onClick={() => navigate("/")}
                >
                  Contact Us
                </button>
              </motion.div>
            </motion.div>
          </AnimatePresence>

          <div className="carousel-dots">
            {slides.map((_, i) => (
              <div key={i} className={`carousel-dot ${i === page ? "active" : ""}`} />
            ))}
          </div>
        </div>
      </motion.div>

      {/* About Section */}
      <div className="about-section">
        <h2 className="about-title">Anthem Group</h2>
        <h3 className="about-subtitle">Creating Abodes of Happiness</h3>
        <p className="about-text">
          Founded in 1995, Anthem Group is an ISO 9001:2008 certified company with
          a turnover of over ₹1000 crore. Built on strong pillars of Financial Services,
          Medicines, and Real Estate, Anthem is redefining the standards of quality
          and trust in the Indian infrastructure industry.
        </p>
        <p className="about-text">
          The real estate sector is one of the fastest-growing industries in India.
          Anthem ensures that each construction process undergoes stringent quality
          checks to guarantee customer satisfaction. The group is driven by a team of
          experienced professionals delivering the best in the industry.
        </p>
        <p className="about-text">
          In the financial services division, Anthem has partnered with Blue Chip MNC
          and PSU clients, while its medical sector fulfills the global demand for
          medicines and surgical equipment across 34 countries.
        </p>
        <p className="about-highlight">
          “Transforming the way people perceive quality” — that’s the Anthem vision.
        </p>
      </div>

      

      {/* Projects Section */}
      <div className="clients-section">
        <h2 className="clients-title">Our Projects</h2>
        <p className="clients-subtitle">
          From “French Apartments” in Greater Noida to “Kingdom Mall & Homes” in Raj Nagar Extension, Anthem Group continues to deliver excellence.
        </p>

        <Slider
          className="clients-slider"
          infinite={true}
          speed={600}
          slidesToShow={4}
          slidesToScroll={1}
          autoplay={true}
          arrows={false}
          autoplaySpeed={1500}
          responsive={[
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } },
          ]}
        >
          <div className="client-logo">
            <img src={require("../assets/client/C1.png")} alt="Project 1" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C2.png")} alt="Project 2" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C3.png")} alt="Project 3" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C4.png")} alt="Project 4" />
          </div>
        </Slider>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.8 }}
          style={{ textAlign: "center", marginTop: "20px" }}
        >
          <button className="cta-button" onClick={() => navigate("/")}>
            Contact Us
          </button>
        </motion.div>
      </div>
{/* Purpose Section */}
<div className="purpose-section">
  <h2 className="purpose-title">Our Purpose</h2>
  <p className="purpose-subtitle">
    At <strong>Anthem Yash Kirti Infracity Pvt. Ltd</strong>, our mission is to empower customers
    with seamless access to project information and updates.
  </p>
  <div className="purpose-cards">
    <div className="purpose-card">
      <span className="purpose-icon">🏗️</span>
      <h4>Sales</h4>
      <p>Helping clients explore and invest in premium residential & commercial spaces.</p>
    </div>
    <div className="purpose-card">
      <span className="purpose-icon">📊</span>
      <h4>Construction Status Updates</h4>
      <p>Real-time progress tracking and transparency for ongoing projects.</p>
    </div>
    <div className="purpose-card">
      <span className="purpose-icon">📂</span>
      <h4>Downloads</h4>
      <p>Easy access to brochures, floor plans, legal documents, and project specifications.</p>
    </div>
  </div>
</div>

     {/* Location Advantage Section */}
<div className="location-section">
  <h2 className="location-title">Location Advantage</h2>
  <div className="location-cards">
    <div className="location-card">🏙️ Main Road Property (NH-58 at doorstep)</div>
    <div className="location-card">🛣️ Elevated Road Distance – 3 KM</div>
    <div className="location-card">🚆 Rapid Train within – 1 KM</div>
    <div className="location-card">🏏 Cricket Stadium – 3.5 KM</div>
    <div className="location-card">🏥 Hospital – 6 KM</div>
    <div className="location-card">🛤️ Peripheral Highway – 6 KM</div>
    <div className="location-card">🛣️ National Highway – 5 KM</div>
    <div className="location-card">🚇 Metro Station – 3 KM</div>
    <div className="location-card">🌳 City Forest – 2 KM</div>
    <div className="location-card">✈️ Hindon Airport – 15 KM</div>
    <div className="location-card">🛍️ Adjacent to KW 6 Mall</div>
    <div className="location-card">🏦 SBI, HDFC, and ICICI Banks within 500 meters</div>
  </div>
</div>

    </>
  );
};

export default Home;
